import {ProfileResponse} from "./ProfileResponse";

type Proposal = Omit<ProfileResponse, "profileIdForProposal"> & { profileIdForProposal: string }

export const isProposal = (profile: ProfileResponse): profile is Proposal =>
    profile.profileIdForProposal !== undefined && profile.profileIdForProposal !== null;